import React, { useEffect } from 'react';

const PaymentSuccess = () => {
  useEffect(() => {
    alert('Payment successful!');
    // Optionally, verify payment via backend
  }, []);

  return <div>Payment Successful! Thank you.</div>;
};

export default PaymentSuccess;